import apiClient from "@/services/apiClient";

export const staffUserService = {
  list: (params) => apiClient.get("/StaffUsers", { params }).then((r) => r.data),
  accountTypes: () => apiClient.get("/StaffUsers/account-types").then((r) => r.data),
  options: () => apiClient.get("/StaffUsers/options").then((r) => r.data),
  create: (data) => apiClient.post("/StaffUsers", data).then((r) => r.data),
  update: (id, data) => apiClient.put(`/StaffUsers/${id}`, data).then((r) => r.data),
  setEnabled: (id, enabled) => apiClient.post(`/StaffUsers/${id}/status`, { enabled }).then((r) => r.data),
  remove: (id) => apiClient.delete(`/StaffUsers/${id}`).then((r) => r.data),
  resetPassword: (id, data) => apiClient.post(`/StaffUsers/${id}/reset-password`, data).then((r) => r.data),
  unlinkedTrainers: () => apiClient.get("/AdminTrainer/unlinked-profiles").then((r) => r.data),
  availableTrainerCredentials: () => apiClient.get("/AdminTrainer/available-credentials").then((r) => r.data),
  createTrainerPortal: (trainerId, data) => apiClient.post(`/AdminTrainer/${trainerId}/portal-account`, data).then((r) => r.data),
  linkTrainerCredential: (trainerId, adminCredentialId) => apiClient.post(`/AdminTrainer/${trainerId}/link-credential`, { adminCredentialId }).then((r) => r.data),
  unlinkTrainerCredential: (trainerId) => apiClient.delete(`/AdminTrainer/${trainerId}/link-credential`).then((r) => r.data),
};
